<template>
  <div id="app">

    <header-component />

    <main-component></main-component>

  </div>
</template>

<script>
import HeaderComponent from '@/components/Header'
import MainComponent from '@/views/Layout'
import i18n from '@/i18n'

export default {
  name: 'App',
  components: {
    HeaderComponent,
    MainComponent,
  },
  data () {
    return {
    }
  },
  metaInfo () {
    return {
      titleTemplate: i18n.tc('siteTitle'),
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'initial-scale=1, width=device-width,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no' },
      ],
      link: [
        { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Muli:wght@400;700&display=swap' },
        { rel: 'preconnect', href: 'https://fonts.gstatic.com' }
      ]
    }
  }
}
</script>

